import React from 'react';
import { CTAButton } from './ui/CTAButton';
import { ShieldCheckIcon } from 'lucide-react';
export function OfferSection() {
  return <section id="oferta" className="py-24 bg-gradient-to-br from-brand-coral to-[#c94254] relative overflow-hidden" data-id="element-71">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-72">
        <div className="absolute -top-24 -left-24 w-96 h-96 bg-white/10 rounded-full blur-3xl" data-id="element-73"></div>
        <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-brand-yellow/20 rounded-full blur-3xl translate-x-1/3 translate-y-1/3" data-id="element-74"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-75">
        <h2 className="text-3xl md:text-5xl font-bold text-white mb-8 leading-tight" data-id="element-76">
          Recupera tu paz mental y asegura la nutrición de tus hijos por menos
          de lo que cuesta una cena rápida para dos.
        </h2>

        <p className="text-xl text-white/90 mb-12 max-w-2xl mx-auto" data-id="element-77">
          Por solo $19 obtienes el sistema completo que te ahorrará más de 100
          horas de estrés al año.
        </p>

        <div className="bg-white rounded-3xl p-8 md:p-12 shadow-2xl max-w-2xl mx-auto transform hover:scale-[1.01] transition-transform duration-300" data-id="element-78">
          <div className="inline-flex items-center gap-2 bg-brand-teal/10 text-brand-teal px-4 py-2 rounded-full font-bold text-sm mb-6" data-id="element-79">
            <ShieldCheckIcon className="w-4 h-4" data-id="element-80" />
            Pago único - Acceso de por vida
          </div>

          <div className="flex flex-col items-center mb-8" data-id="element-81">
            <div className="flex items-center gap-3 mb-2" data-id="element-82">
              <span className="text-2xl md:text-3xl text-brand-brown/40 line-through font-bold" data-id="element-83">
                $19
              </span>
              <span className="bg-brand-coral text-white text-sm font-bold px-3 py-1 rounded-full" data-id="element-84">
                -66% OFF
              </span>
            </div>
            <div className="flex items-baseline gap-2" data-id="element-85">
              <span className="text-6xl md:text-7xl font-bold text-brand-coral" data-id="element-86">
                $6.39
              </span>
              <span className="text-xl text-brand-brown/60 font-medium" data-id="element-87">
                USD
              </span>
            </div>
            <p className="text-sm text-brand-teal font-semibold mt-2" data-id="element-88">
              ¡Precio especial por tiempo limitado!
            </p>
          </div>

          <CTAButton href="https://www.tumomentovital.com/cart/47612278636736:1" className="w-full text-lg md:text-xl py-5 mb-4" data-id="element-89">
            ¡SÍ, QUIERO MIS MAÑANAS SIN ESTRÉS!
          </CTAButton>

          <p className="text-sm text-brand-brown/60 font-medium" data-id="element-90">
            Descarga inmediata. Acceso seguro.
          </p>
        </div>
      </div>
    </section>;
}